<template>
    <a-table :columns="columns" 
            :data-source="myItems" 
            rowKey="index"
    >
        <template slot="index" slot-scope="text, record, index">
            <p>{{ index + 1 }}</p>
        </template>

        <template slot="quantity" slot-scope="text, record, index">
            <a-input-number id="inputNumber" 
                            v-model="record.quantity" 
                            :min="1" 
                            :max="100"
                            @change="handleUpdateItemQuantity(record)"
            />
        </template>

        <template slot="expandedRowRender" slot-scope="record" style="margin: 0">
            <div>
                <p v-for="(op, index) in record.options" :key="index">
                    {{ op.description + ' (' + op.addedPrice + 'kr)' + ' :' + getOptions(op.options) }} 
                </p>
                <p>
                    {{ record.shortDescription }} 
                </p>                            
                <p> {{ record.comment }} </p>
            </div>
        </template>

        <template slot="discount" slot-scope="text, record, index">
            <h6 class="m-0">
				<a-tag v-if="record.discount > 0.0" color="red" class="ant-tag-success font-bold">
                    {{ record.discount }}%
                </a-tag>
                <a-tag v-else color="green" class="ant-tag-success font-bold">
                    {{ record.discount }}%
                </a-tag>
			</h6>
        </template >

        <template slot="actions" slot-scope="text, record, index">
			<a-button-group>
				<edit-item-in-cart-popover :addonsJSON="record.addonsJSON"
                                        :groupOptionsJSON="record.groupOptionsJSON"
                                        :rowIndex="index"
                                        @onSubmit="handleEditItemInCartOnSubmit"
                />
                <a-popconfirm title="Are you sure to delete?"
                                ok-text="Yes"
                                cancel-text="No"
                                @confirm="handleBtnDeleteItem(index)"
                >
                    <a-button shape="circle" 
                            icon="delete" 
                            size="small" 
                    />
                </a-popconfirm>
                                            
			</a-button-group>
		</template>
    </a-table>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import EditItemInCartPopover from '../../components/popovers/EditItemInCartPopover.vue'
export default {

    components : {
        EditItemInCartPopover,
    },

    computed : {
        ...mapGetters({
            productsByCategoryId : 'phoneService/productsByCategoryId'
        }),
    },

    data () {
        return {
            columns : [
                {
					title: '#', dataIndex: 'index', scopedSlots: { customRender: 'index' },
				},
                {
					title: 'ITEM', dataIndex: 'itemName',
				},
                {
					title: 'PRICE', dataIndex: 'price'
				},
                {
					title: 'ADDEDPRICE', dataIndex: 'addedPrice'
				},
                {
                    title: 'DISCOUNT', dataIndex: 'discount', scopedSlots: { customRender: 'discount' }
                },
                {
                    title: 'QUANTITY', dataIndex: 'quantity', scopedSlots: { customRender: 'quantity' }
                },
                {
			        title : 'ACTION', scopedSlots : { customRender: 'actions'}, fixed: 'right'
		        }
            ],
            myItems : []
        }
    },

    methods : {
        ...mapMutations({
            handleEditItemInCartOnSubmit : 'ordering/EDIT_ITEM_IN_CART_STATE',
            //handleBtnDeleteItem : 'ordering/REMOVE_ITEM_FROM_CART_STATE',
            //handleUpdateItemQuantity: 'ordering/UPDATE_ITEM_QUANTITY_IN_CART_STATE',
        }),
        getOptions(options) {
            let description = '';
            for (let i = 0; i < options.length; i++) {
                if(options.length - (i+1) > 0) {
                    description += options[i].description + ' - ';
                }
                else {
                    description += options[i].description;
                }
            }
            
            return description;
        },

        handleBtnDeleteItem(e) {
            this.$store.commit('ordering/REMOVE_ITEM_FROM_CART_STATE', e);

            let maxTime = this.$store.state.phoneService.orderManagerState.maxWaitingTime;
            let currentWaitingTime = this.$store.state.phoneService.orderManagerState.currentWaitingTime;
            this.$store.commit('ordering/UPDATE_ESTIMATED_TIME_STATE');
            this.$store.commit('ordering/UPDATE_ESTIMATED_PICKUP_TIME_STATE', {'minWaitingTime' : currentWaitingTime, 'maxWaitingTime' : maxTime });
        },
 
        handleUpdateItemQuantity(e) {
            console.log('update item quantity!')
            this.$store.commit('ordering/UPDATE_ITEM_QUANTITY_IN_CART_STATE', e);

            let maxTime = this.$store.state.phoneService.orderManagerState.maxWaitingTime;
            let currentWaitingTime = this.$store.state.phoneService.orderManagerState.currentWaitingTime;
            this.$store.commit('ordering/UPDATE_ESTIMATED_TIME_STATE');
            this.$store.commit('ordering/UPDATE_ESTIMATED_PICKUP_TIME_STATE', {'minWaitingTime' : currentWaitingTime, 'maxWaitingTime' : maxTime });
        }


        
    },
    created() {
        this.myItems = this.$store.state.ordering.cart;
    }
}
</script>

<style>

</style>